import React, { useCallback } from "react";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { normalizarEnvolvido } from "./envolvidoUtils";

function Envolvido({ envolvido, setBoletim, setEnvolvido, setModoEdicao }) {
  const identificador = envolvido.id || envolvido._id;

  const handleRemoveEnvolvido = useCallback(() => {
    if (!window.confirm(`Deseja excluir o cadastro de ${envolvido.nome || "este envolvido"}?`)) return;
    setBoletim((prev) => ({
      ...prev,
      envolvidos: prev.envolvidos.filter((item) =>
        String(item.id || item._id) !== String(identificador)
      ),
    }));
  }, [envolvido.nome, identificador, setBoletim]);

  const handleClickEditar = useCallback(() => {
    setModoEdicao(true);
    setEnvolvido(normalizarEnvolvido(envolvido));
  }, [setModoEdicao, setEnvolvido, envolvido]);

  return (
    <div className="envolvido-item">
      <div className="envolvido-main">
        <div className="envolvido-nome">{envolvido.nomeSocial || envolvido.nome}</div>
        <div className="envolvido-meta">
          <span className="envolvido-tipo">{envolvido.tipo}</span>
          {envolvido.conduzido && <span className="envolvido-tipo">Conduzido</span>}
          {envolvido.alcunha && <span className="envolvido-nascimento">Alcunha: {envolvido.alcunha}</span>}
          {envolvido.bairro && (
            <span className="envolvido-nascimento">{envolvido.bairro}</span>
          )}
        </div>
      </div>

      <div className="envolvido-actions">
        <button
          type="button"
          className="envolvido-btn editar"
          onClick={handleClickEditar}
          aria-label={`Editar ${envolvido.nome || "envolvido"}`}
        >
          <MdEdit size={18} />
        </button>

        <button
          type="button"
          className="envolvido-btn excluir btn-danger"
          onClick={handleRemoveEnvolvido}
          aria-label={`Excluir ${envolvido.nome || "envolvido"}`}
        >
          <MdDeleteForever size={18} />
        </button>
      </div>
    </div>
  );
}

export default Envolvido;
